import { HTTP } from "@/api";
import moment from "moment";

export default {
  buySub(_, _id) {
    return new Promise((resolve, reject) => {
      // HTTP.post("/score/stripe/create-checkout-session", {
      //   _id
      // })
      HTTP.post("/v2/pay/stripe/create", {
        _id,
      })
        .then((res) => {
          let data = res.data;
          if (data.success) resolve(data.url);
          else reject(data.message);
        })
        .catch(reject);
    });
  },
  continueSub({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      HTTP.post("/v2/pay/stripe/continue", {
        id,
      })
        .then((res) => {
          let data = res.data;
          dispatch("session");
          if (data.success) resolve(true);
          else reject(data.message);
        })
        .catch(reject);
    });
  },
  cancelSub({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      HTTP.post("/v2/pay/stripe/cancel", {
        id,
      })
        .then((res) => {
          let data = res.data;
          dispatch("session");
          if (data.success) resolve(true);
          else reject(data.message);
        })
        .catch(reject);
    });
  },
  buyCoingateSub(_, id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/v2/pay/coingate/create`, {
        sub: id,
      })
        .then((res) => {
          const data = res.data;
          console.log(data);
          if (data.success) resolve(data.url);
          else reject(data.message);
        })
        .catch(reject);
    });
  },
  buyNowpaymentSub(_, id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/v2/pay/nowpayment/create`, {
        sub: id,
      })
        .then((res) => {
          const data = res.data;
          console.log(data);
          if (data.success) resolve(data.url);
          else reject(data.message);
        })
        .catch(reject);
    });
  },
  checkNowpayment(_) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/v2/pay/nowpayment/is-live`)
        .then((res) => {
          const data = res.data;

          if (data.success) resolve(true);
          else reject(false);
        })
        .catch(reject);
    });
  },
  portal() {
    return new Promise((resolve, reject) => {
      HTTP.post("/score/stripe/create-portal-session")
        .then((res) => {
          let data = res.data;
          if (data.success) resolve(data.url);
          else reject(data.message);
        })
        .catch(reject);
    });
  },
  getSubscription({ commit }) {
    return new Promise((resolve, reject) => {
      HTTP.get("/score/sub?status=true")
        .then((res) => {
          let data = res.data;
          if (data && data.success) {
            commit("getSubscription", data.result);
            resolve(data.result);
          } else reject("Subscription fetching failed!");
        })
        .catch(reject);
    });
  },
  setSub({ state }, status) {
    state.hasSub = status;
    state.subDaysLeft = !status
      ? 0
      : moment(state.user.subscription.end).diff(moment(), "days", true);
  },
  checkSub({ state, dispatch }) {
    if (!state.session) return false;
    return HTTP.post("/score/auth/sub").then((res) => {
      const data = res.data;
      if (data.success) {
        if (window.$cookies.isKey("session")) {
          const c = window.$cookies.get("session");

          window.$cookies.set(
            "session",
            {
              user: { ...c.user, subscription: data.subscription },
              session: c.session,
            },
            c.session.expiresIn,
          );
        }
        dispatch("session");
        return data.result;
      }
    });
  },
};
